import { useSelector } from 'react-redux';
import { selectRegionId, selectTransportAccessibility } from 'shared/selectors/houseInfo';
import { renderHighways, renderRailways, renderUndergrounds } from './utils';
import { TransportAccessibility } from 'shared/components/TransportAccessibility';
import { useMemo } from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { Shutter } from 'shared/components/Shutter';

export const TransportAccessibilityContainer = () => {
  const { undergrounds, highways, railways } = useSelector(selectTransportAccessibility);
  const regionId = useSelector(selectRegionId);
  const items = useMemo(
    () => [
      ...(undergrounds?.length ? renderUndergrounds(undergrounds, regionId) : []),
      ...(highways?.length ? renderHighways(highways, regionId) : []),
      ...(railways?.length ? renderRailways(railways) : []),
    ],
    [highways, railways, regionId, undergrounds],
  );
  const deviceType = useDeviceType();

  const maxHeight = useMemo(() => {
    if (deviceType === 'desktop') {
      return 24;
    }

    return items.slice(0, 3).length * 24;
  }, [deviceType, items]);

  if (!items.length) {
    return null;
  }

  return (
    <Shutter maxHeight={maxHeight} closedText="Посмотреть все" openedText="Свернуть все">
      <TransportAccessibility items={items} />
    </Shutter>
  );
};
